import { render, staticRenderFns } from "./CustomerMemberships.vue?vue&type=template&id=c9637d0e&scoped=true"
import script from "./CustomerMemberships.vue?vue&type=script&lang=ts"
export * from "./CustomerMemberships.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMemberships.vue?vue&type=style&index=0&id=c9637d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9637d0e",
  null
  
)

export default component.exports